import { defineStore } from 'pinia';

const useMovieStore = defineStore('movie', {
  state: () => ({
    selectedMovieId: null,
    selectedMovieName: '',
    movieList: [],
  }),
  actions: {
    setSelectedMovie(movieId, movieName) {
      this.selectedMovieId = movieId;
      this.selectedMovieName = movieName || '';
    },
    setMovieList(list) {
      this.movieList = list;
    },
    clearSelectedMovie() {
      this.selectedMovieId = null;
      this.selectedMovieName = '';
    },
  },
  getters: {
    getSelectedMovieName: (state) => {
      if (state.selectedMovieName) {
        return state.selectedMovieName;
      }
      // 如果没有直接存储名称，从 movieList 中查找
      if (state.selectedMovieId && state.movieList.length > 0) {
        const movie = state.movieList.find((item) => item.id === state.selectedMovieId);
        return movie?.name || '';
      }
      return '';
    },
  },
});

export default useMovieStore;

